import { call, put, takeLatest } from "redux-saga/effects";
import { t } from "utils/i18n";

import Action from "reducers/Action";

/***************** TYPES *********************/

import { Message } from "types/Message";

/*************** CONSTANT ******************/
import { RESET_PACKAGE } from "constant/processus";

/*************** ACTIONS **************/
import { addMessage } from "actions/messages";

/********************* API *****************/
import { resetPackage } from "api/processus";

/**
 * Permet de lancer un reset des packages en base
 * @param action action redux
 */
function* resetDbPackage(action: Action<{}>) {
  try {
    yield call(resetPackage);
    const message: Message = {
      code: "",
      message: t("commun_packages_reset"),
      type: "SUCCESS",
      target: "GLOBAL"
    };
    yield put(addMessage(message));
  } catch {
    console.error("erreur lors du lancement du reset des packages ");
    const message: Message = {
      code: "",
      message: t("commun_packages_reset_error"),
      type: "DANGER",
      target: "GLOBAL"
    };
    yield put(addMessage(message));
  }
}

// export d'une liste qui est utilisée dans l'index des saga
const sagas: any[] = [takeLatest(RESET_PACKAGE, resetDbPackage)];

export default sagas;